import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Tabs } from 'antd'
import ChangeAvatar from '../change-avatar/ChangeAvatar'
import ChangeColor from '../change-color/ChangeColor'
import ChangePassword from '../change-password/ChangePassword'
import ChangeLogo from '../change-logo/ChangeLogo'
import { validateAdmin } from '../../utils/index'
import ChangeLanguage from '../change-language/ChangeLanguage'

const { TabPane } = Tabs

export class Settings extends Component {

  render() {
    const {
      defaultActiveKey
    } = this.props;
    return (
      <Tabs defaultActiveKey={defaultActiveKey}>
        <TabPane tab={<FormattedMessage id="language" />} key="0">
          <ChangeLanguage />
        </TabPane>
        <TabPane tab="Avatar" key="1">
          <ChangeAvatar handleHideAvatar={this.props.hideSettings} />
        </TabPane>
        <TabPane tab="Color" key="2">
          <ChangeColor handleHideColor={this.props.hideSettings} />
        </TabPane>
        <TabPane tab={<FormattedMessage id="my_account" />} key="3">
          <ChangePassword close={this.props.hideSettings} />
        </TabPane>
        {validateAdmin() && <TabPane tab={<FormattedMessage id="settings_logo" />} key="4">
          <ChangeLogo handleHideLogo={this.props.hideSettings} />
        </TabPane>}
      </Tabs >
    )
  }
}

const mapStateToProps = state => {
  return {
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  }
}

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Settings)))
